import type { FC, ReactNode } from "react";
import { Button, Modal, Text } from "@uhg-harmony/react";
import type { ModalProps } from "@uhg-harmony/react";

export type BaseConfirmationModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title?: ReactNode;
  bodyText: ReactNode;
  confirmLabel: string;
  confirmVariant?: "primary" | "destructive";
};

export const BaseConfirmationModal: FC<BaseConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm",
  bodyText,
  confirmLabel,
  confirmVariant = "primary",
}) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <>
      {open && (
        <Modal
          open={open}
          title={title}
          aria-label={typeof title === "string" ? title : "Confirm"}
          onClose={onClose}
        >
          <Modal.Body>
            <Text size="xlarge">{bodyText}</Text>
          </Modal.Body>

          <Modal.Actions>
            <Button variant="secondary" onPress={onClose}>
              Cancel
            </Button>
            <Button variant={confirmVariant} onPress={handleConfirm}>
              {confirmLabel}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </>
  );
};
